import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionDataService } from './../services/session-data.service';
import { UtilitiesService } from './utilities.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private sessionDataService: SessionDataService,
    private UTS: UtilitiesService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // let kioskId = this.sessionDataService.getMachineHostName();
    // const clonedRequest = httpRequest.clone({
    //   withCredentials: true,
    //   headers: new HttpHeaders({
    //     "X-CSRF-TOKEN": "553cca62-d162-4b22-8e34-278f394827bf", //16cdd2c6-5b3f-4f78-814d-b5a8d4982d8d
    //     "kiosk-id": kioskId != null ? kioskId : '',
    //     "Channel": "links",
    //     "transactionId": Date.now().toString()
    //   })
    // });
    // return next.handle(clonedRequest);
    if (
      this.UTS.getENV().toLocaleLowerCase() == 'mobile' &&
      this.UTS.getAccessToken() && 
      this.UTS.getJSessionID()
    ) {
      const accessToken = this.UTS.getAccessToken();
      const header = {
        Channel: this.UTS.getENV().toLocaleUpperCase(),
        transactionId: Date.now().toString(),
        'access-token': accessToken,
        'JSESSIONID':this.UTS.getJSessionID(),
        authorization: 'Bearer ' + accessToken,
        'content-type': 'application/json',
        'Accept-Encoding': 'UTF-8',
        Accept: 'application/json',
        "MagentoCartId":this.UTS.getMagentoCartId(),
        "wso2AccessToken": this.UTS.getWSO2AccessToken(),
        "individualLoginAccountNo": this.UTS.getIndividualLoginAccountNo(),
        BigIpServer: (this.UTS.getBigIpServer() && this.UTS.getBigIpServer() != "") ?
        this.UTS.getBigIpServer() : null,
      };
      if (!header['MagentoCartId']) {
        delete header['MagentoCartId'];
      }
      if (!header['wso2AccessToken']) {
        delete header['wso2AccessToken'];
      }
      if (!header['BigIpServer']) {
        delete header['BigIpServer'];
      }
      if (!header['individualLoginAccountNo']) {
        delete header['individualLoginAccountNo'];
      }

      if(localStorage.getItem('language')=='ar') header['Locale'] = 'ar_AE';
      else header['Locale'] = 'en_AE';
      
      request = request.clone({
        headers: new HttpHeaders(header),
        withCredentials: true,
      });
    } else {
      request = request.clone({
        headers: new HttpHeaders({
          Channel: this.UTS.getENV().toLocaleUpperCase(),
          transactionId: Date.now().toString(),
          "Locale": localStorage.getItem('language')=='ar'?'ar_AE':'en_AE',
          "X-CSRF-TOKEN": "bf6ef30e-5ebd-41d2-a6e2-63499a269d171"
        }),
        withCredentials: true,
      });
    }

    return next.handle(request);
  }
}
